import { useState, useEffect, useRef } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import SVG from "react-inlinesvg";
import * as actions from "../../../_redux/school-reports/SchoolReportsAction";
import { redirectToPages, resultAlert } from "../../../../../../_helpers/Helpers";
import { useSubheader } from "../../../../../../_metronic/layout";
import "../../../../../../_metronic/_assets/sass/pages/wizard/wizard-4.scss";
import KTWizard from "../../../../../../_metronic/_assets/js/components/wizard";
import { toAbsoluteUrl } from "../../../../../../_metronic/_helpers";
import { 
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  ModalProgressBar
} from "../../../../../../_metronic/_partials/controls";
import { SchoolReportWizardNav } from "./SchoolReportWizardNav";
import { ReportDefinitionEditForm } from "./ReportDefinitionEditForm";

export function SchoolReportAdd({ history }) {
  // Subheader
  const suhbeader = useSubheader();
  const [title, setTitle] = useState("");
  const dispatch = useDispatch();
  const { actionsLoading, isSuccess, type, schoolReport } = useSelector(
    (state) => ({
      actionsLoading: state.schoolReports.actionsLoading,
      isSuccess: state.schoolReports.isSuccess,
      type: state.schoolReports.type,
      schoolReport: state.schoolReports.schoolReport
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.getSchoolReport());
    return () => dispatch(actions.cleanSchoolReportsState());
  }, [dispatch]);
  
  useEffect(() => {
    let _title = "Okul Karnesi Ekle";
    setTitle(_title);
    suhbeader.setTitle(_title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // School Report Form Wizard
  const options = {
    startStep: 1,
    clickableSteps: false
  };

  new KTWizard(document.querySelector("#school_report_form_wizard"), options);

  /** Belli Bir Okul Karnesini Kaydeder */
  const saveSchoolReport = (values) => {
    dispatch(actions.saveSchoolReport(values)).then((result) => onResult(result));
  };
  
  const onResult = ({ entity, isSuccess, type, message }) => {
    resultAlert(type, message);
    if (isSuccess) setTimeout(() => history.push(`/ogrenci-okul-karneleri/duzenle/${entity.id}/2`), 2500)
  };

  const btnRef = useRef();
  const saveSchoolReportClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);
  
  return (
    // <!--begin: Wizard -->
    <div
      className="wizard wizard-4"
      id="school_report_form_wizard"
      data-wizard-state="step-first"
    >
      <Card>
        <CardHeader title={title} />
        <CardBody>
          {/* <!--begin: Form Wizard Nav --> */}
          <SchoolReportWizardNav />
          {/* <!--end: Form Wizard Nav --> */}
        </CardBody>
      </Card>
            
      {/* <!--begin: Form Wizard Form--> */}
      {/* <!--begin: Form Wizard Step 1--> */}
      <div data-wizard-type="step-content" data-wizard-state="current">
        <Card>
          {actionsLoading && <ModalProgressBar />}
          <CardHeader title="Karne Tanımı">
            <CardHeaderToolbar>
              <button
                type="submit"
                className="btn btn-primary"
                onClick={saveSchoolReportClick}
              >
                Kaydet ve İlerle
                <span className="svg-icon svg-icon-md ml-1">
                  <SVG src={toAbsoluteUrl("/media/svg/icons/Navigation/Arrow-right.svg")} />
                </span>
              </button>
            </CardHeaderToolbar>
          </CardHeader>
          <CardBody>
            <ReportDefinitionEditForm
              schoolReport={schoolReport}
              btnRef={btnRef} 
              saveSchoolReport={saveSchoolReport}
            />
          </CardBody>
        </Card>
      </div>
      {/* <!--end: Form Wizard Step 1--> */}
      {/* <!--end: Form Wizard Form--> */}
    </div>          
    // <!--end: Wizard -->
  );
}